import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";

export default function Root({ pageType }) {
  return (
    <GoogleOAuthProvider clientId="751134488799-ejsm5bi8nb6tn78oosf1c7d9d4s1ufb0.apps.googleusercontent.com">
      <App pageType={pageType} />
    </GoogleOAuthProvider>
  );
}

